import { api } from "../common/utils"
import { AI_AMENDMENTS_ENDPOINT } from "../common/constants"

export interface Amendment {
  _id: string
  level: string
  levelId: string
  text: string
  enabled: boolean
  createdAt?: string
  updatedAt?: string
}

export interface CreateAmendmentPayload {
  level: string
  levelId: string
  text: string
}

export interface UpdateAmendmentPayload {
  text?: string
  enabled?: boolean
}

const aiAmendmentsApi = {
  list: (level: string, levelId: string) =>
    api
      .get(AI_AMENDMENTS_ENDPOINT, { params: { level, levelId } })
      .then(r => (Array.isArray(r.data) ? r.data : r.data?.amendments ?? [])),
  create: (payload: CreateAmendmentPayload) =>
    api.post(AI_AMENDMENTS_ENDPOINT, payload).then(r => r.data),
  update: (id: string, payload: UpdateAmendmentPayload) =>
    api.patch(`${AI_AMENDMENTS_ENDPOINT}/${id}`, payload).then(r => r.data),
  delete: (id: string) => api.delete(`${AI_AMENDMENTS_ENDPOINT}/${id}`)
}

export default aiAmendmentsApi
